import { render, staticRenderFns } from "./TemplateCompare.vue?vue&type=template&id=71be869e&scoped=true"
import script from "./TemplateCompare.vue?vue&type=script&lang=js"
export * from "./TemplateCompare.vue?vue&type=script&lang=js"
import style0 from "./TemplateCompare.vue?vue&type=style&index=0&id=71be869e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71be869e",
  null
  
)

export default component.exports